import { render } from "./StudentDeviceRgistration.vue?vue&type=template&id=23e8dfe2&scoped=true"
import script from "./StudentDeviceRgistration.vue?vue&type=script&lang=js"
export * from "./StudentDeviceRgistration.vue?vue&type=script&lang=js"

import "./StudentDeviceRgistration.vue?vue&type=style&index=0&id=23e8dfe2&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e8dfe2"]])

export default __exports__